module.exports = __webpack_public_path__ + "static/SeeVita-05-9675dbdfe8259fb91b439e3f6145ad0c.png";